import { BuyerOrderItem, SellerOrderItem } from 'src/types'

interface MergeOrderItemsArgs<T extends BuyerOrderItem | SellerOrderItem> {
  newOrderItem: T
  oldOrderItem: T
}

export const mergeOrderItems = <T extends BuyerOrderItem | SellerOrderItem>({
  newOrderItem,
  oldOrderItem,
}: MergeOrderItemsArgs<T>): T => {
  const mergedOrderItem = {
    ...oldOrderItem,
    ...newOrderItem,
    frontendDesignation: oldOrderItem.frontendDesignation, // temporary fix because pusher does not use the user's language for the payload and always uses French
    productName: oldOrderItem.productName, // temporary fix because pusher does not use the user's language for the payload and always uses French
    permissions: oldOrderItem.permissions,
    originSellerProductInstance: (oldOrderItem as SellerOrderItem).originSellerProductInstance,
  }

  return mergedOrderItem
}
